import React, { useCallback, useContext } from 'react'
import clsx from 'clsx'
import { useTranslation } from '../../hooks'
import DataContext from '../../DataContext/Context'
import type { ButtonProps } from '../../../../components/button/Button'
import Button from '../../../../components/button/Button'
import { check } from '../../../../icons'
import withComponentMarkers from '../../../../shared/helpers/withComponentMarkers'

export type IsolationCommitButtonProps = ButtonProps

function IsolationCommitButton(props: IsolationCommitButtonProps) {
  const translations = useTranslation().Isolation

  const { className, children, text, ...rest } = props

  const content = text || children || translations.commitButtonText

  const { handleSubmit, props: dataContextProps } =
    useContext(DataContext) || {}
  const { isolate } = dataContextProps || {}

  const onClickHandler = useCallback(() => {
    if (isolate) {
      handleSubmit?.()
    }
  }, [handleSubmit, isolate])

  return (
    <Button
      variant="secondary"
      className={clsx('dnb-forms-isolate__commit-button', className)}
      icon={check}
      iconPosition="left"
      onClick={onClickHandler}
      {...rest}
    >
      {content}
    </Button>
  )
}

withComponentMarkers(IsolationCommitButton, {
  _supportsSpacingProps: true,
})

export default IsolationCommitButton
